import { Shadow, Stack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface DataListContainerProps {
  children: React.ReactNode;
}

export const DataListContainer: React.FC<DataListContainerProps> = ({ children }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return <Stack mt="stack.xxs">{children}</Stack>;
  }

  return (
    <Shadow level={1} p="inset.sm" borderRadius={BoxBorder.heavy} mt="stack.xxs">
      {children}
    </Shadow>
  );
};
